const _excluded = ["type"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Checkbox, MenuItem, TextButton, TextField, Typography, WithInfoIcon } from 'seagull';
import { serviceModel } from "../../models";
import styles from "./ServiceAdvancedSettings.module.scss";
import { AdvancedSetting, getSettings } from "./ServiceAdvancedSettings.utils";
import { useStoreActions } from "../../contexts";

function AdvancedSettingsControl(props) {
  const {
    info,
    checked,
    testid,
    label,
    tooltip,
    disabled,
    children,
    onChange: _onChange
  } = props;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: info
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    disabled: disabled,
    tooltip: tooltip ? {
      placement: 'top',
      title: tooltip
    } : undefined,
    "data-testid": testid,
    onChange: e => _onChange(e.target.checked)
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: disabled ? 'disabled' : 'standard'
  }, label))), children);
}

function PausedControl(props) {
  const {
    service,
    testPrefix,
    disabled,
    info,
    label,
    tooltip,
    onPausedChange
  } = props;
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.Pause,
    info: info,
    label: label,
    checked: serviceModel.isPaused(service),
    testid: testPrefix + '-start-paused',
    disabled: disabled,
    tooltip: tooltip,
    onChange: checked => onPausedChange && onPausedChange(service.id, checked)
  });
}

function BillOnApprovalControl(props) {
  const {
    service,
    testPrefix,
    disabled,
    label,
    tooltip,
    info,
    onBillOnAcceptanceChange
  } = props;
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.BillOnApproval,
    info: info,
    label: label,
    checked: !serviceModel.isSkipBillingOnAcceptance(service),
    testid: testPrefix + '-bill-on-acceptance',
    disabled: disabled,
    tooltip: tooltip,
    onChange: checked => onBillOnAcceptanceChange && onBillOnAcceptanceChange(service.id, checked)
  });
}

function ProrateControl(props) {
  const {
    service,
    testPrefix,
    disabled,
    tooltip,
    label,
    info,
    onProratedChange
  } = props;
  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.Prorate,
    info: info,
    label: label,
    checked: serviceModel.isProrated(service),
    testid: testPrefix + '-prorated',
    disabled: disabled,
    tooltip: tooltip,
    onChange: checked => onProratedChange && onProratedChange(service.id, checked)
  });
}

function OptionalControl(props) {
  const {
    service,
    info,
    label,
    onOptionalChange
  } = props;
  const {
    logBI
  } = useStoreActions();

  const onChangeWithBI = data => {
    logBI(10488, _objectSpread(_objectSpread({}, data), {}, {
      serviceId: service.id,
      serviceName: service.name
    }));
    onOptionalChange && onOptionalChange(service.id, data.optional, data.includedByDefault);
  };

  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.Optional,
    info: info,
    label: label,
    checked: service.participation.type === 'optional',
    testid: "".concat(service.id, "-toggle-optional"),
    onChange: checked => onChangeWithBI({
      optional: checked,
      includedByDefault: false
    })
  }, serviceModel.isOptional(service.participation) && /*#__PURE__*/React.createElement("div", {
    className: styles.additionalControl
  }, /*#__PURE__*/React.createElement(Typography, null, "Set the default state of this service:"), /*#__PURE__*/React.createElement(TextField, {
    select: true,
    size: "small",
    width: 274,
    "data-testid": "".concat(service.id, "-included-dropdown"),
    value: service.participation.optional.includedByDefault.toString(),
    onChange: e => onChangeWithBI({
      optional: true,
      includedByDefault: e.target.value === 'true'
    })
  }, /*#__PURE__*/React.createElement(MenuItem, {
    "data-testid": "".concat(service.id, "-option-not-included"),
    value: "false"
  }, "Not included in the proposal"), /*#__PURE__*/React.createElement(MenuItem, {
    "data-testid": "".concat(service.id, "-option-included"),
    value: "true"
  }, "Included in the proposal"))));
}

function LimitChargesControl(props) {
  const {
    service,
    showServiceValidationWarning = false,
    info,
    label,
    onLimitBillingTimesChange
  } = props;
  const {
    logBI
  } = useStoreActions();
  const [wasModified, setWasModified] = useState(false);
  const maxChargesError = serviceModel.validateMaxCharges(service).length > 0;

  const onChangeWithBI = data => {
    logBI(10489, _objectSpread(_objectSpread({}, data), {}, {
      serviceId: service.id,
      serviceName: service.name
    }));
    onLimitBillingTimesChange && onLimitBillingTimesChange(service.id, data.limit, data.count);
  };

  return /*#__PURE__*/React.createElement(AdvancedSettingsControl, {
    key: AdvancedSetting.LimitCharges,
    info: info,
    label: label,
    checked: serviceModel.maxChargesEnabled(service),
    testid: "".concat(service.id, "-toggle-limit-billing-count"),
    onChange: checked => onChangeWithBI({
      limit: checked,
      count: serviceModel.maxChargesLimit(service)
    })
  }, serviceModel.maxChargesEnabled(service) && /*#__PURE__*/React.createElement("div", {
    className: styles.additionalControl
  }, /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    label: "Number of times",
    width: 274,
    "data-testid": "".concat(service.id, "-limit-billing-count-input"),
    value: serviceModel.maxChargesLimit(service) != null ? serviceModel.maxChargesLimit(service) : '',
    error: maxChargesError && (wasModified || showServiceValidationWarning),
    onChange: e => {
      if (e.target.value !== '' && !Number.isNaN(Number(e.target.value))) {
        setWasModified(true);
        onChangeWithBI({
          limit: true,
          count: Number(e.target.value)
        });
      } else if (e.target.value === '') {
        setWasModified(true);
        onChangeWithBI({
          limit: true,
          count: null
        });
      }
    },
    helperText: maxChargesError && (wasModified || showServiceValidationWarning) ? 'Must be between 1 and 99' : ''
  })));
}

export const ServiceAdvancedSettings = /*#__PURE__*/React.forwardRef(function ServiceAdvancedSettings(props, ref) {
  const {
    service,
    testPrefix,
    showServiceValidationWarning,
    isApprovedRelationship
  } = props;
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(serviceModel.isProrated(service) || serviceModel.isOptional(service.participation));
  const settings = getSettings(service, isApprovedRelationship);
  useImperativeHandle(ref, () => ({
    showAdvancedSettings
  }), [showAdvancedSettings]);
  useEffect(() => {
    if (showServiceValidationWarning) {
      setShowAdvancedSettings(true);
    }
  }, [showServiceValidationWarning]);
  return settings.length === 0 ? null : showAdvancedSettings ? /*#__PURE__*/React.createElement("div", {
    className: styles.settings,
    "data-testid": testPrefix + '-advanced-settings'
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "normal"
  }, "Advanced settings:"), settings.map(_ref => {
    let {
      type
    } = _ref,
        rest = _objectWithoutProperties(_ref, _excluded);

    const controlProps = _objectSpread(_objectSpread({
      key: type
    }, props), rest);

    switch (type) {
      case AdvancedSetting.Pause:
        return /*#__PURE__*/React.createElement(PausedControl, controlProps);

      case AdvancedSetting.BillOnApproval:
        return /*#__PURE__*/React.createElement(BillOnApprovalControl, controlProps);

      case AdvancedSetting.Prorate:
        return /*#__PURE__*/React.createElement(ProrateControl, controlProps);

      case AdvancedSetting.Optional:
        return /*#__PURE__*/React.createElement(OptionalControl, controlProps);

      case AdvancedSetting.LimitCharges:
        return /*#__PURE__*/React.createElement(LimitChargesControl, controlProps);
    }
  })) : /*#__PURE__*/React.createElement(TextButton, {
    underline: "hover",
    "data-testid": testPrefix + '-open-adv-settings',
    onClick: () => setShowAdvancedSettings(true)
  }, "Show Advanced settings...");
});